import axios from "axios";
import { clearLogoutData } from "../logout/action";
import { CommonListing_URL, User_Service_URL, Partner_Service_URL } from "../Url";

export const partnerSaveActions = {
  SAVE_PARTNER_INFO_SUCCESS: "SAVE_PARTNER_INFO_SUCCESS",
  SAVE_PARTNER_INFO_ERROR: "SAVE_PARTNER_INFO_ERROR",
};

export const getAllUserByRoleRmActions = {
  GET_ALL_USER_BY_ROLE_RM_LOADING: "GET_ALL_USER_BY_ROLE_RM_LOADING",
  GET_ALL_USER_BY_ROLE_RM_SUCCESS: "GET_ALL_USER_BY_ROLE_RM_SUCCESS",
  GET_ALL_USER_BY_ROLE_RM_ERROR: "GET_ALL_USER_BY_ROLE_RM_ERROR",
};

export function savePartnerDetails(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${CommonListing_URL}/addNewPartnerFirm`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveApplicantDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveApplicantDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveApplicantDetailsError(err));
          return err.response;
        }
      });
}

export function saveApplicantDetailsError(error) {
  return {
    type: partnerSaveActions.SAVE_PARTNER_INFO_ERROR,
    payload: error,
  };
}

export function saveApplicantDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: partnerSaveActions.SAVE_PARTNER_INFO_SUCCESS,
      payload: props,
    });
  };
}

export function getAllUserByRoleRm(props) {
  const { access_token } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/get/AllUserByRoleRm`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getAllUserByRoleRmSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getAllUserByRoleRmError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          // dispatch(getAllUserByRoleRmError(err));
          return err.response;
        }
      });
}

export function getAllUserByRoleRmError(error) {
  return {
    type: getAllUserByRoleRmActions.GET_ALL_USER_BY_ROLE_RM_ERROR,
    payload: error,
  };
}

export function getAllUserByRoleRmSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getAllUserByRoleRmActions.GET_ALL_USER_BY_ROLE_RM_SUCCESS,
      payload: props,
    });
  };
}

export function getAllUserByRoleRmLoading() {
  return (dispatch) => {
    dispatch({
      type: getAllUserByRoleRmActions.GET_ALL_USER_BY_ROLE_RM_LOADING,
    });
  };
}

export function verifypan(props) {
  const { access_token, values } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/verifyPartnerPANDetails`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {

          return response;
        } else {
          const error = new Error(response.statusText);

          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          return err.response;
        }
      });

}
